import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import { useState } from "react";
import Lottie from "lottie-react";
import docAnimation from "./doc.json";
import { FirebaseService } from "@shared/lib/services/firebase.service";

interface UploadScriptModalProps {
  isUploading: boolean;
  uploadScripting: (url: string) => void;
  scriptId: string;
}

export function UploadScriptModal(props: UploadScriptModalProps) {
  const { scriptId, isUploading, uploadScripting } = props;
  const [isLocalUploading, setIsLocalUploading] = useState<boolean>(false);

  const beforeUpload: UploadProps["beforeUpload"] = (file) => {
    const isTxt = file.type === "text/plain";
    const isPdf = file.type === "application/pdf";
    if (!isTxt && !isPdf) {
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const customRequest = async (options: any) => {
    const { file, onSuccess, onError } = options;
    try {
      setIsLocalUploading(true);
      const url = await FirebaseService.uploadFileToFirebase(
        `script/${scriptId}`,
        file as File
      );
      uploadScripting(url);
      onSuccess && onSuccess(url);
    } catch (e) {
      onError && onError(e);
    } finally {
      setIsLocalUploading(false);
    }
  };

  const uploading = isUploading || isLocalUploading;

  return (
    <div>
      {uploading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 240,
          }}
        >
          <Lottie
            animationData={docAnimation}
            loop
            style={{ width: 220, height: 220 }}
          />
        </div>
      ) : (
        <Upload.Dragger
          multiple={false}
          accept=".txt,.pdf"
          beforeUpload={beforeUpload}
          customRequest={customRequest}
          maxCount={1}
          showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Only .txt or .pdf files are supported
          </p>
        </Upload.Dragger>
      )}
    </div>
  );
}
